<template>
  <v-container class="fill-height pa-0" fluid>
    <v-row class="ma-0 pa-0 fill-height">
      <v-col cols="12" class="d-flex pt-0 pr-0 justify-center align-baseline fill-height"
             :style="`padding-left: 250px`">
        <transition
            enter-active-class="transition-ease-in-out"
            leave-active-class="transition-ease-in-out">
          <router-view></router-view>
        </transition>
      </v-col>
    </v-row>
    <v-navigation-drawer
        v-if="$vuetify.breakpoint.lgAndUp"
        class="elevation-6"
        style="z-index: 0"
        :value="true"
        width="240"
        hide-overlay
        color="primary"
        fixed>
      <v-list-item two-line style="padding-top: 70px">
        <v-list-item-avatar size="40" color="white">
          <v-icon>mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="white--text">{{ user.name }}</v-list-item-title>
          <v-list-item-subtitle class="white--text">{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item-group dark>
        <template v-for="(item, i) in menu">
          <v-list-item :key="i"
                       @click="$router.push({name: item.route}).catch( error => {})">
            <v-list-item-icon class="d-flex justify-center">
              <v-icon size="20">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="white--text">
              <v-badge v-if="unread > 0 && item.hasOwnProperty('unread')"
                       offset-x="25"
                       offset-y="20"
                       :content="unread" color="danger">
                <v-list-item-title>{{ item.content }}</v-list-item-title>
              </v-badge>
              <v-list-item-title v-else>{{ item.content }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-icon class="d-flex justify-center">
            <v-icon size="20">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="white--text"
                               v-if="$vuetify.breakpoint.lgAndUp">{{ $t('logout') }}</v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import Pusher from 'pusher-js'
export default {
  name: "Dashboard",
  data () {
    return {
      pusher: new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
        cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
        forceTLS: true
      })
    }
  },
  created() {
    this.getUnread()
  },
  mounted() {
    this.$root.$on('get-unread', () => {
      this.getUnread()
    })
    this.subscribe()
  },
  beforeDestroy() {
    this.unbind()
  },
  methods: {
    getUnread () {
      this.$http.get('api/v2/auth/unread')
          .then(response => {
            this.$store.dispatch('setUnread', response.data.unread)
          })
    },
    logout () {
      this.$http.post('api/v2/auth/logout')
          .then(response => {
            this.$store.dispatch('setAlert', {show: true, type: 'success', message: response.data.message})
            this.$store.dispatch('setAuthorization', null)
            this.$store.dispatch('setUser', null)
            this.$router.push({ name: 'main' })
          })
    },
    subscribe () {
      this.pusher
          .subscribe('channel.message')
          .bind('new.message', () => {
              this.getUnread()
              this.getTickets()
          })
    },
    unbind () {
      this.pusher
          .unbind('new.message')
    },
    getTickets () {
      this.$store.dispatch('setLoading', true);
      this.$http.get('api/v2/auth/tickets')
          .then((response) => {
            this.$store.dispatch('setMails', response.data.tickets);
          })
          .finally(() => {
            this.$store.dispatch('setLoading', false);
          })
    }
  },
  computed: {
    menu () {
      return this.$store.getters.GET_USER && this.$store.getters.GET_USER.role.includes('admin') ?
          this.$t('admin.menu') :
          this.$t('user.menu')
    },
    user () {
      return this.$store.getters.GET_USER ? this.$store.getters.GET_USER : {}
    },
    unread () {
      return this.$store.getters.GET_UNREAD
    }
  }
}
</script>

<style scoped>

</style>
